import {educatAPI, RestQueryParams} from 'educat-common-web';
import {Observable} from 'rxjs';

export function getInquiryVariantsAPI(): Observable<any> {
    return educatAPI.get('inquiry_variants', new RestQueryParams(), {});
}